import CustomerPage from "../pages/administrative/customer";
import RedemptionPage from "../pages/administrative/redemption";
import RewardPage from "../pages/administrative/reward";

export const adminProtectedRoutes = [
    {
        label: 'Prêmios',
        path: '/premios',
        element: <RewardPage />
    },
    {
        label: 'Clientes',
        path: '/clientes',
        element: <CustomerPage />
    },
    {
        label: 'Resgates',
        path: '/resgates',
        element: <RedemptionPage />
    }
];